import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';

import { HELPER_NAV_SCROLL_THRESHOLD } from '@/components/GlobalNavigation/DesktopNav/DesktopNav';

const useHelperNav = (
  scrollPosition: number,
  scrollDirection: string
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [isHelperNav, setIsHelperNav] = useState(false);
  // Introduce helper nav when user scrolls downs to mid page
  useEffect(() => {
    if (
      scrollDirection === 'down' &&
      scrollPosition > HELPER_NAV_SCROLL_THRESHOLD
    ) {
      setIsHelperNav(true);
    }
  }, [scrollPosition, scrollDirection]);

  return [isHelperNav, setIsHelperNav];
};

export default useHelperNav;
